import { Component } from 'react'
import { DragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import './drag-wrapper.css'

class DragManagerWrapper extends Component {
  render() {
    return this.props.children
  }
}

export const dragSourceWrapper = (connectDragSource, draggable, children) => (
  draggable ?
    connectDragSource(children) :
    children
)


export default DragDropContext(HTML5Backend)(DragManagerWrapper)




// WEBPACK FOOTER //
// ./src/drag-drop/index.jsx